// extracted by mini-css-extract-plugin
module.exports = {"subLabel":"InputLabel_subLabel__sP_gz"};